import React, { useContext, useState } from 'react';
import { feedbackReportsDelete } from '../../api';
import { useHistory } from "react-router-dom";
import { UserContext } from '../../context/User';
import { useForm } from 'react-hook-form';
import { deleteReportNotice, somethingWentWrongNotice } from '../UI/Notifications';
import { SearchContext } from '../../context/Search';
import Modal from '../UI/Modal';

const DeleteReport = ({ id, closeDeleteModal, showDelete }) => {
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const history = useHistory();
  const { setSearchTrigger, searchTrigger, setLoading } = useContext(SearchContext);
  const [show, setShow] = useState(showDelete);
  const { handleSubmit } = useForm();

  const handleClose = () => {
      setShow(false);
      closeDeleteModal();
  }
  const handleShow = () => setShow(true);

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push("/");
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout();
    } else {
      somethingWentWrongNotice("Delete Report");
    }

    setLoading(false);
  }

  const onSubmit = () => {
    setLoading(true);
    feedbackReportsDelete({feedback_id: id})
      .then(() => {
        handleClose();
        setSearchTrigger(!searchTrigger);
        setLoading(false);
        deleteReportNotice();
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        handleClose();
      });
  }

  return (
    <>
      <Modal 
        handleClose={handleClose} 
        show={show}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        buttonLabel="Delete"
      >
        <h5 className="mb-4">Are you sure you want to delete this report?</h5>
      </Modal>
    </>
  )
}

export default DeleteReport;
